import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          国产91视频为手机看视频移动端播放提供全方位保障
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuresData.map((feature, index) => (
            <div
              key={feature.id}
              className={`p-5 md:p-6 rounded-xl border cursor-pointer transition-all duration-300 hover:border-primary-200/60 ${
                index === 0
                  ? 'bg-accent-50/70 border-accent-200/60'
                  : 'bg-background-50 border-background-200/70'
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                index === 0
                  ? 'bg-accent-100 text-accent-600'
                  : 'bg-primary-50 text-primary-500'
              }`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}